/**
 * Article TOC — sommaire flottant pour les pages article.
 *
 * Scan les <h2> du .rte, leur assigne un id si absent, et injecte un
 * <aside class="article-toc"> fixé dans la marge droite (desktop ≥ 1280px).
 * La section active est trackée via la position des headings au scroll
 * (rAF-throttled, pas d'IntersectionObserver pour éviter les flickers
 * quand un h2 sort du viewport entre deux).
 *
 * Caché en CSS sous 1280px — sur mobile/tablet le TOC n'a pas sa place.
 */
(function () {
  'use strict';

  // N'agit que sur les pages article : présence de `.article .rte`
  const rte = document.querySelector('.article .rte');
  if (!rte) return;

  const headings = Array.from(rte.querySelectorAll('h2'));
  // En dessous de 2 sections, un sommaire n'apporte rien
  if (headings.length < 2) return;

  // --- Slug helper : génère un id à partir du texte du heading ---
  const usedIds = new Set();
  const slugify = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // strip diacritiques (combining marks)
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const items = headings.map((h) => {
    if (!h.id) {
      const base = slugify(h.textContent || '') || 'section';
      let candidate = base;
      let i = 1;
      while (usedIds.has(candidate) || document.getElementById(candidate)) {
        candidate = base + '-' + ++i;
      }
      h.id = candidate;
    }
    usedIds.add(h.id);
    // Décale le scroll target pour que le titre ne colle pas au header sticky
    h.style.scrollMarginTop = '100px';
    return { id: h.id, text: (h.textContent || '').trim(), el: h };
  });

  // --- Build markup ---
  const aside = document.createElement('aside');
  aside.className = 'article-toc';
  aside.setAttribute('aria-label', 'Sommaire');

  const title = document.createElement('p');
  title.className = 'article-toc__title';
  title.textContent = 'Sommaire';

  const list = document.createElement('ol');
  list.className = 'article-toc__list';

  items.forEach(({ id, text }) => {
    const li = document.createElement('li');
    li.className = 'article-toc__item';
    const a = document.createElement('a');
    a.href = '#' + id;
    a.className = 'article-toc__link';
    a.textContent = text;
    li.appendChild(a);
    list.appendChild(li);
  });

  aside.appendChild(title);
  aside.appendChild(list);
  document.body.appendChild(aside);

  // --- Section active tracking ---
  // Stratégie : on prend le dernier heading dont le top est ≤ 120px
  // (zone d'activation = 120px sous le bord du viewport). Pas de
  // flicker en bordure et premier heading actif au-dessus du fold.
  const links = Array.from(aside.querySelectorAll('.article-toc__link'));
  const ACTIVATION_OFFSET = 120;

  let ticking = false;
  function updateActive() {
    // Visibilité du TOC : seulement quand on est en train de lire le corps
    // de l'article (rte croise la zone d'activation). Avant on est dans la
    // bannière (TOC se superposait), après on est dans les commentaires
    // ou les blocs liés (TOC flottait dans le vide).
    const rteRect = rte.getBoundingClientRect();
    const isReading = rteRect.top <= ACTIVATION_OFFSET && rteRect.bottom >= ACTIVATION_OFFSET;
    aside.classList.toggle('is-visible', isReading);

    // Section active : dernier h2 dont le top est passé sous le seuil
    let activeIndex = 0;
    for (let i = 0; i < items.length; i++) {
      if (items[i].el.getBoundingClientRect().top <= ACTIVATION_OFFSET) {
        activeIndex = i;
      } else {
        break;
      }
    }
    links.forEach((l, i) => l.classList.toggle('is-active', i === activeIndex));
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(updateActive);
        ticking = true;
      }
    },
    { passive: true }
  );

  // Initial paint
  updateActive();
})();
